import API, { apiWhatsapp } from "../../api";
import { queryClient } from "../../react-query"

import {useMerchant} from "../../../store/global/useMerchant";
import {formatResponses} from "../../formatResponses/whatsapp";
import {useWhatsapp} from "../../../store/service-activation/useWhatsapp";
import {toast} from "react-toastify";


export class WhatsappModel {
  whatsappActions = useWhatsapp.getState().actions

  async getConfig() {
    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['whatsapp', 'config'],
        queryFn: async () => await API.get("whatsapp/config"),
      })

      this.whatsappActions.setConfig(formatResponses.formatConfig(result.data.config))
      return result.data
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar as configurações do Checklist', { theme: 'colored' })
      return {}
    }
  }
  async updateReminderHour(hour) {
      try {
        const now = new Date()
        now.setHours(hour, 0, 0, 0)

      const result = await API.put('whatsapp/reminder-hour', {hour:now.getUTCHours()})

      queryClient.setQueryData(['whatsapp', 'config'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      this.whatsappActions.setConfig(formatResponses.formatConfig(result.data.config))

      return result.data
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível atualizar o horário do Lembrete', { theme: 'colored' })
      return false
    }
  }
  async disconnect() {
    const storeId = useMerchant.getState().data.merchant.id
    if(!storeId) return

    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['whatsapp', 'connection','disconnect'],
        queryFn: async () => await apiWhatsapp.delete(`/whatsapp-connection/${storeId}`),
        gcTime: 1000 * 2
      })

      // this.whatsappActions.setConnection(formatResponses.formatConnection(result.data.connection))
      return result.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async connect() {
    const storeId = useMerchant.getState().data.merchant.id
    if(!storeId) return

    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['whatsapp', 'connection', 'connect'],
        queryFn: async () => await apiWhatsapp.get(`/whatsapp-connection/${storeId}`),
        gcTime: 1000 * 2
      })
      return result.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async deactivate() {
    const storeId = useMerchant.getState().data.merchant.id
    if(!storeId) return
    this.whatsappActions.setActive(false)
    try {
      const [result] = await Promise.all([API.delete('whatsapp/instance'), this.disconnect()])

      queryClient.setQueryData( ['whatsapp', 'config'], (oldData) => {
        if (!oldData?.data) return { data:  [result.data]}
        return {
          ...oldData,
          data: result.data,
        }
      })

      this.whatsappActions.setConfig(formatResponses.formatConfig(result.data.config))
      return result.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
  async activate() {
    const storeId = useMerchant.getState().data.merchant.id
    if(!storeId) return
    this.whatsappActions.setActive(true)

    try {
      apiWhatsapp.post(`/whatsapp-instance/${storeId}`).catch(()=>{})
      const [result] = await Promise.all([API.post('whatsapp/instance'), this.connect()])

      queryClient.setQueryData( ['whatsapp', 'config'], (oldData) => {
        if (!oldData?.data) return { data:  [result.data]}
        return {
          ...oldData,
          data: result.data,
        }
      })

      this.whatsappActions.setConfig(formatResponses.formatConfig(result.data.config))
      return result.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }

  async getConnection() {
    const storeId = useMerchant.getState().data.merchant.id
    const isActive = useWhatsapp.getState().data.config.active

    if(!storeId || !isActive) return
    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['whatsapp', 'connection', 'status', storeId],
        queryFn: async () => await apiWhatsapp.get(`/whatsapp-instance/${storeId}`),
        gcTime: 1000
      })
      this.whatsappActions.setConnection(formatResponses.formatConnectionInstance(result.data.instance))
      return result.data
    } catch (error) {
      console.error(error)
      return {}
    }
  }
}


